//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            alertColumns: [
                { name: 'rank', label: 'Rank', field: 'rank', sortable: true, align: 'left', autoWidth: true },
                { name: 'text', label: 'Text', field: r => [r.text, r.key], sortable: true, align: 'left', cellType: 'big-small' },
                { name: 'item', label: 'Item', field: this.getItemInfo, sortable: true, align: 'left', cellType: 'big-small' },
                { name: 'created', label: 'Created', field: 'created', format: this.formatDateTime, sortable: true, align: 'left' },
                { name: 'status', label: 'Dismissed', field: this.getDismissed, format: this.formatDateTime, sortable: true, align: 'left' },
            ],
            alerts: [],
        };
    },

    methods: {
        getItemLabel({ collName, itemId }) {
            const item = !collName ? null : $.findById($[collName], itemId);

            if (!item)
                return;

            switch (collName) {
                case 'cases': return item.code;
                case 'claims': return `${item.externalId} ${$.formatDate(item.occuredDate)}`;
                case 'vehicles': return [item.make, item.model, item.variant, item.rz].filter(v => v).join(' ');
                default: return itemId;
            }
        },
        getDetail({ collName, itemId }) {
            return $.getDetail(types[collName].pageName, itemId);
        },
        dismiss(alert) {
            $.set(alert, 'dismissed', true);

            alert.dismissTimeout = setTimeout(() => this.doDismiss(alert), 5000);
        },
        async doDismiss(alert) {
            const { key, itemId, userId } = alert;

            await axios.delete('/alerts', { params: { key, itemId, userId } });

            $.removeOne(this.alerts, alert);
        },
        undoDismiss(alert) {
            clearTimeout(alert.dismissTimeout);

            alert.dismissed = false;
            alert.dismissTimeout = null;
        },
        async fetchData() {
            await $.fetchAll('settings', 'cases', 'vehicles', 'clients', 'persons', 'claims');

            this.alerts = (await axios('/myAlerts')).data;
        },
        async fetchDataPeriodically() {
            if (!$.getSetting('hideAlerts')) {
                await this.fetchData();

                const fetchPeriodSecs = $.getSetting('alertsFetchPeriodSecs');

                if (fetchPeriodSecs > 0) {
                    await $.delay(fetchPeriodSecs * 1000);

                    this.fetchDataPeriodically();
                }
            }
        },
    },

    @cancellableFetch
    async mounted() {
        await this.fetchDataPeriodically();
    },
};
